import { render, staticRenderFns } from "./Fraction.vue?vue&type=template&id=34e03ee6&scoped=true"
import script from "./Fraction.vue?vue&type=script&lang=js"
export * from "./Fraction.vue?vue&type=script&lang=js"
import style0 from "./Fraction.vue?vue&type=style&index=0&id=34e03ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e03ee6",
  null
  
)

export default component.exports